export default "__VITE_ASSET__144e3606__"